// @flow
import { SAVE_PARENT_LOCATION } from '../../../ActionsConst';

type Action = {
  type: string,
  parentLocation: string | null,
};

type State = {
  parentLocation: string | null,
};

const initialState = {
  parentLocation: null,
};

const fullUploadState = (state: State = initialState, action: Action) => {
  switch (action.type) {
    case SAVE_PARENT_LOCATION:
      return { ...state, parentLocation: action.parentLocation };
    default:
      return state;
  }
};

export default fullUploadState;
